import React from 'react';
import './styles.css';
import SvgIcon, { iconList } from '../../../share/components/iconSVG';

function AnyQuestions({ title }) {
  return (
    <section className='anyQuestionsContainer'>
      <div className='anyQuestions'>
        <p className='anyQuestionsTitle'>{title}</p>

        <div className='anyQuestionsOptionsList'>
          <div className='anyQuestionsOption'>
            <div className='anyQuestionsOptionIcon'>
              <SvgIcon name={iconList.IconPinMap} color={'#17AEE6'} size={40} />
            </div>
            <p className='anyQuestionsOptionText'>Puntos de atención</p>
          </div>
          <div className='anyQuestionsOption'>
            <div className='anyQuestionsOptionIcon'>
              <SvgIcon name={iconList.IconChat} color={'#17AEE6'} size={40} />
            </div>
            <p className='anyQuestionsOptionText'>Chat en línea</p>
          </div>
          <div className='anyQuestionsOption'>
            <div className='anyQuestionsOptionIcon'>
              <SvgIcon name={iconList.IconPhoneRing} color={'#17AEE6'} size={40} />
            </div>
            <p className='anyQuestionsOptionText'>Llamanos a nuestra línea</p>
          </div>
          <div className='anyQuestionsOption'>
            <div className='anyQuestionsOptionIcon'>
              <SvgIcon name={iconList.IconCall} color={'#17AEE6'} size={40} />
            </div>
            <p className='anyQuestionsOptionText'>Nosotros te llamamos</p>
          </div>
          <div className='anyQuestionsOption'>
            <div className='anyQuestionsOptionIcon'>
              <SvgIcon name={iconList.IconMegaPhone} color={'#17AEE6'} size={40} />
            </div>
            <p className='anyQuestionsOptionText'>Contáctanos por Redes sociales</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AnyQuestions;
